import { Toast } from 'mint-ui';

let common={
    getlocalStorage(name) {
        let data = localStorage.getItem(name) || "";
        const arr = data.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
        if (arr != null) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    },
    setlocalStorage(name, value,days) {
        const Days = days||30;
        const exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        localStorage.setItem(name,name + "=" + escape(value) + ";expires=" + exp.toGMTString());
    },
    deletelocalStorage(name){
        localStorage.clear();
    },
    //设置cookie
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    },
    //获取cookie
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return "";
    },
    //清除cookie
    clearCookie() {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if(keys) {
            for(var i = keys.length; i--;){
                document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
            }
        }
    },
    //封装弹出框函数;
    toast(text){
        let instance =Toast({  
            message: text, //提示内容分
            position: "middle", //提示框位置
            duration: 3000 , //持续时间（毫秒），若为 -1 则不会自动关闭
            iconClass: "icon icon-success", //icon 图标的类名
            className:"addClass"   //Toast 的类名。可以为其添加样式
        });  
    }

};

export default common



// WEBPACK FOOTER //
// ./src/common.js